'use client';
import Typography from '@/components/shared/typography/typography.component';

import styles from './styles.module.scss';
import colors from '@/theme/colors.module.scss';
import { WhiteMarker } from '../../../../../public/Images/Acquisition';
import Image from 'next/image';

interface ISylndrHubLocation {
    header: string;
    subHeader: string;
    sylndrLocationButtonCLick: Function;
}
const SylndrHubLocationButton = ({
    header,
    subHeader,
    sylndrLocationButtonCLick,
}: ISylndrHubLocation) => {
    return (
        <button
            onClick={() => sylndrLocationButtonCLick()}
            className={styles.button}
        >
            <div className={styles.image_container}>
                <div className={styles.spinner} />
                <Image
                    src={WhiteMarker.src}
                    width={WhiteMarker.width}
                    height={WhiteMarker.height}
                    alt="location"
                    className={styles.img}
                />
            </div>
            <div>
                <Typography
                    style={{ width: 'fit-content' }}
                    color={colors.secondary500}
                    variant="body1Medium"
                >
                    {header}
                </Typography>
                <Typography
                    style={{ width: 'fit-content' }}
                    color={colors.secondary500}
                    variant="caption"
                >
                    {subHeader}
                </Typography>
            </div>
        </button>
    );
};
export default SylndrHubLocationButton;
